export const STORAGE_KEY_DEW_SESSION: string = 'localstorage:de.dew21.administration:KEY_SESSION';
